import { render, staticRenderFns } from "./CrossPena.vue?vue&type=template&id=4042bf5a&"
import script from "./CrossPena.vue?vue&type=script&lang=js&"
export * from "./CrossPena.vue?vue&type=script&lang=js&"
import style0 from "./CrossPena.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports